import React from 'react';
import TextField from '@material-ui/core/TextField';


export default function ({ titleError, title, messageError, message, tagsError, tags, onChangeField }) {
	return (
		<React.Fragment>
			<br/>
			<label htmlFor="Titulo"style={{ display: 'block', color: '#BBBBBB' }}>
				Título
			</label>
			<TextField
				fullWidth
				error={titleError !== null && titleError !== ''}
				helperText={titleError}
				value={title}
				onChange={event => onChangeField('title', event.target.value)}
			/>
			<br />
			<br />
			<label htmlFor="Mensagem"style={{ display: 'block', color: '#BBBBBB' }}>
				Mensagem
			</label>
			<TextField
				fullWidth
				error={messageError !== '' && messageError !== null}
				helperText={messageError}
				value={message}
				onChange={event => onChangeField('message', event.target.value)}
			/>
			<br />
			<br />
			<label htmlFor="Tags"style={{ display: 'block', color: '#BBBBBB' }}>
				Tags
			</label>
			<TextField
				fullWidth
				error={tagsError !== '' && tagsError !== null}
				value={tags}
				onChange={event => onChangeField('tags', event.target.value)}
				helperText={tagsError?tagsError:"tag1,tag2,tag3"}
			/>

		</React.Fragment>
	);
}





// WEBPACK FOOTER //
// ./src/components/notification/fields/NotificationBodyField.js